import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0b1014',
      paper: '#182024',
      sidebar: '#0d1519',
      surface: '#151d21',
      surfaceElevated: '#1c262b',
    },
    accent: {
      green: '#35f0aa',
      cyan: '#4fc3f7',
      yellow: '#ffd54f',
    },
    primary: {
      main: '#35f0aa',
      contrastText: '#06100d',
    },
    secondary: {
      main: '#4fc3f7',
    },
    success: {
      main: '#35f0aa',
    },
    text: {
      primary: '#ffffff',
      secondary: '#a9b4bb',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
      color: '#ffffff',
    },
    h5: {
      fontWeight: 600,
      color: '#ffffff',
    },
    button: {
      fontWeight: 800,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#0b1014',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          letterSpacing: 0,
        },
        outlined: {
          borderColor: 'rgba(255,255,255,0.14)',
          color: '#ffffff',
          '&:hover': {
            borderColor: 'rgba(53, 240, 170, 0.45)',
            backgroundColor: 'rgba(53, 240, 170, 0.08)',
          },
        },
        contained: {
          backgroundColor: '#35f0aa',
          color: '#06100d',
          '&:hover': {
            backgroundColor: '#24d895',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 700,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 18px 44px rgba(0,0,0,0.22)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          padding: '4px',
          fontSize: '0.9rem',
        },
        head: {
          backgroundColor: '#3a3a3a',
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '0.9rem',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#182024',
          borderRadius: '12px',
          backgroundImage: 'none',
          boxShadow: '0 18px 44px rgba(0, 0, 0, 0.25)',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#ffffff',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&:disabled': {
            color: 'rgba(255, 255, 255, 0.3)',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          minWidth: 200,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: '#ffffff',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
          },
        },
        icon: {
          color: '#ffffff',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#ffffff',
          backgroundColor: '#2c2c2c',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#182024',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
        },
      },
    },
  },
});
